<template>
  <div class="m-3">
    <b-row>
      <b-col cols="2" v-b-toggle="`accordion-${id}`">
        <b-badge pill :style="{ backgroundColor: color }" class="p-2">
          <b-icon
            icon="bell-fill"
            style="color: #fff"
            :class="{ 'b-icon-animation-fade': isNew }"
          ></b-icon>
        </b-badge>
      </b-col>
      <b-col cols="10">
        <div>
          <p class="m-0 text-notification-item">{{ text }}</p>
          <small class="text-date"> {{ date | formatTimestamp }}</small>
        </div>
      </b-col>
    </b-row>

    <b-collapse
      :id="`accordion-${id}`"
      accordion="accordionNotificationItem"
      role="tabpanel"
      @show="findTextEvent"
    >
      <b-card-body>
        <b-card-text class="text-detail">{{ detail }}</b-card-text>
      </b-card-body>
    </b-collapse>
  </div>
</template>

<script>
import request from "../../request/request";
import { eventPath } from "../../router/ApiPaths";
import EventTypeText from "../../components/extra/EventTypeText";

export default {
  name: "NotificationItem",
  extends: request,
  props: ["id", "type", "date", "isNew"],
  data() {
    return {
      color: "secondary",
      text: "Pendente",
      detail: "",
    };
  },
  watch: {
    type: function (val) {
      this.updateText(val);
    },
  },
  mounted() {
    this.updateText(this.type);
  },
  methods: {
    updateText(val) {
      let result = EventTypeText(val);
      this.text = result.text;
      this.color = result.color;
    },
    findTextEvent() {
      this.get(eventPath + "/" + this.id).then((data) => {
        this.detail = data.text;
      });
    },
  },
};
</script>

<style>
.text-notification-item {
  font-weight: 600;
}
.text-date {
  color: #5a5a5a;
}

.text-detail {
  overflow: hidden;
  position: relative;
  /* line-height: 1.2em; */
  max-height: 6em;
}

.text-detail:before {
    content: '...';
    position: absolute;
    right: 0px;
    bottom: 0;
    background-color: #ffffff;
    padding: 0 0px 0 0.25em;
}
</style>



// WEBPACK FOOTER //
// src/view/header/NotificationItem.vue